import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Logo } from '@saviynt/design-system';
import LogoSvg from '../../../../../../ECMv6/assets/logo/Saviynt-logo.svg';
import WhiteLogo from '../../../../../../ECMv6/assets/logo/Saviynt-logo-white.svg';
import './AppLogo.css';

const AppLogo = ({ src, isWhite, isSideNav, isGen2Nav }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const style = isLoaded ? undefined : { visibility: 'hidden' };

  // Dark mode is active only on License Intelligence pages
  const isDarkTheme = window.location.pathname.includes('/licenseintelligence/');

  // Use design-system Logo component for dark mode
  if (isDarkTheme) {
    return (
      <div className="cl-logo">
        <Logo kind="SaviyntWhite" />
      </div>
    );
  }

 const getLogoSrc = () => {
  if (src) return src;
  if (!isWhite && isSideNav) return WhiteLogo;
  return LogoSvg;
};

  return (
    <div className="cl-logo">
      <img
        src={getLogoSrc()}
        style={style}
        className="cl-logo-icon"
        alt="App Logo"
        data-testid="logo"
        width="100px"
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
};

AppLogo.propTypes = {
  src: PropTypes.string.isRequired,
};

export default AppLogo;
